var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import ContactInformation from "./contact-information.vue";
import TelephoneBook from "~/components/collection-execution/collection-add-list/telephone-book.vue";
import { CaseOperatorPageService } from "~/services/domain-service/case-operator-page.service";
import { FilterService } from "~/utils/filter.service";
import { namespace } from "vuex-class";
var CollectionExecutionModule = namespace('collection-execution');
var EssentialInformation = /** @class */ (function (_super) {
    __extends(EssentialInformation, _super);
    function EssentialInformation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.caseInfo = {};
        _this.information = [
            {
                value: "",
                key: "familyNum",
                label: "家庭人数"
            },
            {
                value: "",
                key: "monthIncome",
                label: "个人月收入"
            },
            {
                value: "",
                key: "incomeCompanyName",
                label: "收入证明单位"
            },
            {
                value: "",
                key: "childNum",
                label: "子女个数"
            },
            {
                value: "",
                key: "houseType",
                label: "房产情况"
            },
            {
                value: "",
                key: "incomeCompanyAddress",
                label: "证明单位地址"
            },
            {
                value: "",
                key: "houseProperty",
                label: "产权性质"
            },
            {
                value: "",
                key: "houseRelegation",
                label: "房屋所有权"
            },
            {
                value: "",
                key: "carName",
                label: "车辆名称"
            },
            {
                value: "",
                key: "houseArea",
                label: "房屋面积"
            },
            {
                value: "",
                key: "archiveNo",
                label: "档案编号"
            },
            {
                value: "",
                key: "partnerId",
                label: "业务团队编号"
            },
            {
                value: "",
                key: "mortgageDate",
                label: "抵押日期"
            },
            {
                value: "",
                key: "color",
                label: "车辆颜色"
            },
            {
                value: "",
                key: "carType",
                label: "车辆类型"
            },
            {
                value: "",
                key: "salesmanName",
                label: "业务员"
            },
            {
                value: "",
                key: "engineNum",
                label: "发动机号"
            },
            {
                value: "",
                key: "carFrameNo",
                label: "车架号"
            },
            {
                value: "",
                key: "gpsAmount",
                label: "GPS个数"
            },
            {
                value: "",
                key: "registrationNo",
                label: "登记证书号"
            },
            {
                value: "",
                key: "dmvName",
                label: "车管所"
            }
        ];
        _this.gpsInfo = [];
        return _this;
    }
    EssentialInformation.prototype.activated = function () {
        this.refreshData();
    };
    EssentialInformation.prototype.refreshData = function () {
        var _this = this;
        this.caseOperatorPageService.queryCaseInfo(this.caseId).subscribe(function (data) {
            _this.gpsInfo = data.gpsInfo;
            _this.information.forEach(function (v) {
                if (v.key === "mortgageDate") {
                    v.value = FilterService.dateFormat(data[v.key]);
                }
                else if (v.key === "houseType") {
                    v.value = _this.$filter.dictConvert(data[v.key], 'HaveNotFlag');
                }
                else if (v.key === "carType") {
                    v.value = _this.$filter.dictConvert(data[v.key], 'CarType');
                }
                else {
                    v.value = data[v.key];
                }
            });
        });
    };
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], EssentialInformation.prototype, "caseOperatorPageService", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], EssentialInformation.prototype, "caseId", void 0);
    EssentialInformation = __decorate([
        Component({
            components: {
                ContactInformation: ContactInformation,
                TelephoneBook: TelephoneBook
            }
        })
    ], EssentialInformation);
    return EssentialInformation;
}(Vue));
export default EssentialInformation;
